import React, { Component } from 'react';

import { Grid, Row } from 'react-bootstrap';

class Feature extends Component {

  render() {  	

  	const featureContent = (
			<div className="col-md-12">
				<h3>{this.props.h3}</h3>
				<div></div>
	            <h4>{this.props.h4}</h4>
	            <h5>{this.props.h5}</h5>
	            {this.props.children}
          	</div>  		
  	);

  	const innerFeatureList = (
			<div>
				<h3>{this.props.h3}</h3>
				<div></div>
	            <h4>{this.props.h4}</h4>
	            <h5>{this.props.h5}</h5>
	            {this.props.children}
          	</div>
  	)

  	const content = this.props.innerFeatureList === true ? innerFeatureList : (this.props.h3 ? featureContent : this.props.children);

    return (
      <div>
      	<div className={'benefit ' + (this.props.shade ? 'shade ' : ' ') + ((this.props.borderless ? 'borderless ' : ' '))}>
		    <Grid fluid={this.props.fluid}>
		        <Row>
		        	{content}
		        </Row>
		    </Grid>
		</div>
      </div>
    );
  }
}

export default Feature;



// WEBPACK FOOTER //
// ./src/content/Feature.js